import circle from './circle.js'
import square from './square.js'
import triangle from './triangle.js'
import diamond from './diamond.js'
import regular from './regular.js'
import star from './star.js'

export const shapes = {
	circle,
	square,
	triangle,
	diamond,
	regular,
	star,
};

export default shapes